"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NounsAuctionHouse__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "nounId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bool",
                name: "extended",
                type: "bool",
            },
        ],
        name: "AuctionBid",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "nounId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "startTime",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "endTime",
                type: "uint256",
            },
        ],
        name: "AuctionCreated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "durationIncreasePercentage",
                type: "uint256",
            },
        ],
        name: "AuctionDurationIncreasePercentageUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "nounId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "endTime",
                type: "uint256",
            },
        ],
        name: "AuctionExtended",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "minBidIncrementPercentage",
                type: "uint256",
            },
        ],
        name: "AuctionMinBidIncrementPercentageUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "reservePrice",
                type: "uint256",
            },
        ],
        name: "AuctionReservePriceUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "nounId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "winner",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "AuctionSettled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "timeBuffer",
                type: "uint256",
            },
        ],
        name: "AuctionTimeBufferUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Paused",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Unpaused",
        type: "event",
    },
    {
        inputs: [],
        name: "auction",
        outputs: [
            {
                internalType: "uint256",
                name: "nounId",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "startTime",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "endTime",
                type: "uint256",
            },
            {
                internalType: "address payable",
                name: "bidder",
                type: "address",
            },
            {
                internalType: "bool",
                name: "settled",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "nounId",
                type: "uint256",
            },
        ],
        name: "createBid",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [],
        name: "duration",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "durationIncreasePercentage",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract INounsToken",
                name: "_nouns",
                type: "address",
            },
            {
                internalType: "address",
                name: "_weth",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_timeBuffer",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_reservePrice",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "_minBidIncrementPercentage",
                type: "uint8",
            },
            {
                internalType: "uint256",
                name: "_duration",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_durationIncreasePercentage",
                type: "uint256",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "minBidIncrementPercentage",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "nouns",
        outputs: [
            {
                internalType: "contract INounsToken",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "paused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "reservePrice",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_durationIncreasePercentage",
                type: "uint256",
            },
        ],
        name: "setDurationIncreasePercentage",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint8",
                name: "_minBidIncrementPercentage",
                type: "uint8",
            },
        ],
        name: "setMinBidIncrementPercentage",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_reservePrice",
                type: "uint256",
            },
        ],
        name: "setReservePrice",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_timeBuffer",
                type: "uint256",
            },
        ],
        name: "setTimeBuffer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "settleAuction",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "settleCurrentAndCreateNewAuction",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "timeBuffer",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalAuctions",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalRaised",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "unpause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "weth",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class NounsAuctionHouse__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.NounsAuctionHouse__factory = NounsAuctionHouse__factory;
NounsAuctionHouse__factory.bytecode = _bytecode;
NounsAuctionHouse__factory.abi = _abi;
